import { render, staticRenderFns } from "./AppMainMenuItem.vue?vue&type=template&id=59a48baf"
import script from "./AppMainMenuItem.vue?vue&type=script&lang=js"
export * from "./AppMainMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports